import clsx from "clsx";
import { ButtonAsButton, ButtonAsLink } from "./index.types";
import "./index.css";
import { ReactElement, ReactNode } from "react";

export const Anchor = ({
  Custom,
  children,
  ...rest
}: {
  Custom?: React.ComponentType<any>;
  children?: ReactNode[];
}) => {
  return Custom ? (
    <Custom {...rest}>{children}</Custom>
  ) : (
    <a {...rest}>{children}</a>
  );
};

export function Button({
  children = "Click me",
  className = "",
  icon = undefined,
  isNewWindow = false,
  mode = "primary",
  size = "medium",
  as = "button",
  CustomAnchor,
  ...rest
}: ButtonAsButton | ButtonAsLink): JSX.Element {
  return as === "link" ? (
    <Anchor
      Custom={CustomAnchor}
      {...(isNewWindow && { target: "_blank" })}
      className={clsx(
        "button",
        `link__${mode}`,
        `button__${size}`,
        className
      )}
      {...(rest as React.AnchorHTMLAttributes<HTMLAnchorElement>)}
    >
      {children}
      {icon}
    </Anchor>
  ) : (
    <button
      className={clsx(
        "button",
        `button__${mode}`,
        `button__${size}`,
        className
      )}
      {...(rest as React.ButtonHTMLAttributes<HTMLButtonElement>)}
    >
      {children}
      {icon}
    </button>
  );
}

export default Button;
